






















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { dateToDisplay } from '@/utils/dateTime'
import { Task } from '@/modules/Task/interfaces/task'
import {
  taskRelationType,
  taskPriority,
  taskPriorityColor
} from '@/modules/Task/helpers/task'

@Component({})
export default class TaskProps extends Vue {
  @Prop() readonly taskInfo!: Task

  dateToDisplay = dateToDisplay
  taskRelationType = taskRelationType
  taskPriority = taskPriority
  taskPriorityColor = taskPriorityColor

  routeToDetail (item: any) {
    let routeName = ''
    switch (item.type) {
      case 'CASE':
        routeName = 'CaseDetailDetail'
        break
      case 'POLICY':
        routeName = 'PolicyDetailDetail'
        break
      case 'ACCOUNT':
        routeName = 'AccountDetailDetail'
        break
      default:
        break
    }
    return {
      name: routeName,
      params: {
        id: item.cell.id
      }
    }
  }
}
